import React, { useEffect, useState } from 'react'
import { fetchArrayStatusByLang, fetchStatusByLang } from '../../list/model'
import { CBadge, CSpinner } from '@coreui/react-pro'
import { Status } from './types'
import { isArray } from 'lodash'

type Props = {
  service: string
  langs: string[] | string
}

export const ServiceStatus: React.FC<Props> = ({ service, langs }) => {
  const [statuses, setStatuses] = useState<Status[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState<boolean>(false)

  useEffect(() => {
    const fetchStatuses = async () => {
      if (isArray(langs)) {
        try {
          const responses = await Promise.all(
            fetchArrayStatusByLang(service, langs),
          )
          const data = (await Promise.all(
            responses.map((response) => response.body),
          )) as Status[]

          setStatuses(data)
          setIsLoading(false)
        } catch (e) {
          setIsError(true)
          setIsLoading(false)
        }
      } else {
        try {
          const response = await fetchStatusByLang(service, langs)
          const data = (await response.body) as Status
          setStatuses([data])
          setIsLoading(false)
        } catch (e) {
          setIsError(true)
          setIsLoading(false)
        }
      }
    }

    setIsLoading(true)
    setIsError(false)
    fetchStatuses()
  }, [service, langs])

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CSpinner color="primary" />
      </div>
    )
  }

  if (isError) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CBadge color="danger">Fail</CBadge>
      </div>
    )
  }

  const backendErrors = statuses
    .filter((status) => status.status === 'STATUS_ERROR')
    .map((status) => status.statusMsg)
    .filter(Boolean)

  if (backendErrors.length > 0) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <CBadge color="danger">{backendErrors.join('; ')}</CBadge>
      </div>
    )
  }

  const isTranslationsFullApproved =
    statuses.length > 0 &&
    statuses.every((status) => status.isTranslationsFullApproved)

  return (
    <div className="d-flex justify-content-center align-items-center gap-1">
      <CBadge color="success">Success</CBadge>
      {isTranslationsFullApproved && (
        <CBadge color="success">Full approved</CBadge>
      )}
    </div>
  )
}
